import type { Ref } from 'react'
import styles from './InfiniteScrollLoader.module.css'
import { Spinner } from '@/components/Spinner'

interface InfiniteScrollLoaderProps {
  isDone: boolean
  compact?: boolean
  /**
   * The element watched for scrolling into view; detached once done.
   */
  ref?: Ref<HTMLDivElement>
}

/**
 * Shown at the end of a list; loads the next page when scrolled into view.
 */
export function InfiniteScrollLoader({
  isDone,
  compact,
  ref,
}: InfiniteScrollLoaderProps) {
  if (isDone) {
    return <div className={compact ? styles.compact : styles.root} />
  }
  return (
    <div className={styles.root} ref={ref}>
      <Spinner />
    </div>
  )
}
